<template>
  <div id="contenedor-contrato-agenda">
    <v-card flat class="rounded-lg pb-3">
      <v-toolbar flat class="pt-3">
        <div style="width: 250px;">
          <v-select
            v-model="filtro"
            :items="filtros"
            outlined
            dense
            label="Filtrar Eventos"
            background-color="#F2F6FF"
            item-id="id"
            item-text="nombre"
            item-value="id"
            hide-details>
            <template v-slot:item="{ item }">
              <v-list-item @click="filtro = item.id">
                <v-list-item-avatar>
                  <v-icon>
                    {{ item.icono }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.nombre }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>
        <v-chip class="ml-2" color="light-blue lighten-5">
          <v-icon small left>
            mdi-calendar-multiple
          </v-icon>
          {{ getFilterEventos.length }} Eventos
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn
          fab
          small
          text
          @click="refreshListadoEventos">
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
        <v-btn
          v-if="!$vuetify.breakpoint.mobile"
          color="primary"
          rounded
          small
          class="text-capitalize ml-2"
          @click="mostrarAgregarEvento = true">
          <v-icon left small>
            mdi-plus
          </v-icon>
          Nuevo Evento
        </v-btn>
        <v-btn
          v-else
          color="primary"
          fab
          small
          class="ml-2"
          @click="mostrarAgregarEvento = true">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="my-3 mx-2"></v-divider>
      <v-row align="start" dense class="mx-2">
        <v-col cols="12" md="3" v-for="(evento) in getFilterEventos" :key="evento.id">
          <Card
            :evento="evento"
            v-on:editarEvento="handleEditarEvento"
            v-on:eliminarEvento="handleEliminarEvento">
          </Card>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog
      v-model="mostrarAgregarEvento"
      scrollable
      width="550px"
      persistent>
      <AddEvento
        :id-contrato="idContrato"
        :numero-contrato="getContrato.numero"
        v-on:cerrar="cerrar">
      </AddEvento>
    </v-dialog>
    <v-dialog
      v-model="mostrarEditarEvento"
      scrollable
      width="550px"
      persistent>
      <EditarEvento v-if="esteEvento"
        :id-contrato="idContrato"
        :numero-contrato="getContrato.numero"
        :edit-evento="esteEvento"
        v-on:cerrar="cerrar">
      </EditarEvento>
    </v-dialog>
    <v-dialog
      v-model="mostrarEliminarEvento"
      scrollable
      width="400px"
      persistent>
      <EliminarEvento
        v-if="esteEvento"
        :evento="esteEvento"
        :numero-contrato="getContrato.numero"
        :id-contrato="idContrato"
        v-on:cerrar="cerrar"></EliminarEvento>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_AGENDA from '@/graphql/querys/administracion/contratos/contrato/agenda/contratoAgendas.gql';
import AddEvento from '@/components/administracion/contratos/contrato/agenda/AddEvento.vue';
import EditarEvento from '@/components/administracion/contratos/contrato/agenda/EditarEvento.vue';
import EliminarEvento from '@/components/administracion/contratos/contrato/agenda/EliminarEvento.vue';
import Card from './Card.vue';

export default {
  name: 'contrato-agenda',
  components: {
    AddEvento,
    EditarEvento,
    EliminarEvento,
    Card,
  },
  data() {
    return {
      idContrato: this.$route.params.idContrato,
      mostrarAgregarEvento: false,
      mostrarEditarEvento: false,
      mostrarEliminarEvento: false,
      esteEvento: null,
      filtro: 'proximos',
      filtros: [
        {
          id: 'proximos',
          nombre: 'Proximos Eventos',
          icono: 'mdi-calendar-clock',
        },
        {
          id: 'concluidos',
          nombre: 'Eventos Concluidos',
          icono: 'mdi-calendar-check',
        },
      ],
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoAgendas: {
      query: CONTRATO_AGENDA,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    refreshListadoEventos() {},
    handleEditarEvento(evento) {
      this.mostrarEditarEvento = true;
      this.esteEvento = evento;
    },
    handleEliminarEvento(evento) {
      this.mostrarEliminarEvento = true;
      this.esteEvento = evento;
    },
    cerrar() {
      this.mostrarAgregarEvento = false;
      this.mostrarEditarEvento = false;
      this.mostrarEliminarEvento = false;
      this.esteEvento = null;
    },
  },
  computed: {
    getContrato() {
      return this.contrato || {};
    },
    getContratoAgenda() {
      if (!this.contratoAgendas) return [];
      return this.contratoAgendas;
    },
    getProximosEventos() {
      if (!this.contratoAgendas) return [];
      return this.contratoAgendas.filter((evento) => {
        const fechaEvento = new Date(`${evento.fecha} ${evento.hora}`);
        const fechaActual = new Date();
        return fechaEvento >= fechaActual;
      }).sort((a, b) => {
        const fechaA = new Date(a.fecha);
        const fechaB = new Date(b.fecha);
        return fechaA - fechaB;
      });
    },
    getEventosVencidos() {
      if (!this.contratoAgendas) return [];
      return this.contratoAgendas.filter((evento) => {
        const fechaEvento = new Date(`${evento.fecha} ${evento.hora}`);
        const fechaActual = new Date();
        return fechaEvento < fechaActual;
      }).sort((a, b) => {
        const fechaA = new Date(a.fecha);
        const fechaB = new Date(b.fecha);
        return fechaB - fechaA;
      });
    },
    getFilterEventos() {
      if (this.filtro === 'proximos') {
        return this.getProximosEventos;
      } if (this.filtro === 'concluidos') {
        return this.getEventosVencidos;
      }
      return this.getProximosEventos;
    },
  },
};
</script>

<style lang="scss">

</style>
